import React, { useEffect, useState } from 'react'
import { BackButton, CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import { NuDate, NuInput, NuInputWithError, NuSelect } from '../../../../Components/Utils/Input';
import FormikSelectTwo, { FormikSelectWithAdd, SelectProductWithError } from '../../../../Components/Utils/Select';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import useAddFormData from '../../../../Components/Hooks/useAddFormData';
import * as yup from 'yup';
import DropDownAddMetaData, { DropDownAddUnitWithError } from '../../../../Components/Utils/selectAddMetaData';
import axiosInstance from '../../../../Services/axiosCommon';
import UseCustomerDropDownNew from '../../../../Components/Hooks/useCustomerSearch';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import { useToast } from '../../../../Components/Others/ToastServices';
import Attachement from '../../../../Components/Utils/CustomAttrachmentupload';
import UseDropDown from '../../../../Components/Hooks/useDropDown';
import DeleteIcon from '../../../../Components/Icons/Delete';
import UseProductDropDownNew from '../../../../Components/Hooks/useProductSearch';
import EditIcon from '../../../../Components/Icons/Edit';
import Select from "react-select";
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import { format, addMonths } from 'date-fns';
import UseDropDownNew from '../../../../Components/Hooks/useDropDownNew';
import MultiSelect, { MultiSelectSet } from '../../../../Components/Utils/MultiSelect';

function CreateContracts() {
   const [expandedIndex, setExpandedIndex] = useState(null);
       const [deliveryRows, setDeliveryRows] = useState([]);
       const now = new Date();
  const navigate = useNavigate();
  const { Oncancel, addFormData, contextHolder, isLoading } = useAddFormData();
  const [searchClient, setSearchClient] = useState("");
  const { data: client, setDataCustomer } = UseCustomerDropDownNew(
    "/clients/drop-down",
    searchClient
  );
 const { data: form } = UseDropDownNew(`/form/drop-down`);
 console.log(form,"sssss");
 
  const { value: supplierCat, getData: refsupplierCat } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "SupplierCategory"
  );
  const { data: Survey } = UseDropDown(`/survey-report/drop-down`);

  const { value: brand,getData:refbrand } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "brand_equipments"
  );
  const { value: unit,getData:refunit } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "unit_equipments"
  );
  const { value: Duration,getData:refDuration } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Duration_Contracts"
  );
  const { value: inspectionType,getData:refinspectionType } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Inspection_Type_Contracts"
  );    
  
      // const { data: client } = UseDropDown(`/clients/drop-down`);
      const [searchequipment, setSearchequipment] = useState("");
      const [sortedProList,setSortedProList] =  useState([]);
      const [oldData, setOldData] = useState([])
  const [items, setItems] = useState([]);
    
      const { data: Item , setDataequipments ,setData} = UseProductDropDownNew(
    
        "/equipments/drop-down",
        searchequipment
      );
      const [newItemData, setNewItemData] = useState({
        equipmentId:"",
       unit:"",
       sno:"",
       quantity:""
      });
    
      const [isEditQua, setIsEditQua] = useState(false);
      const [isEditUnit, setIsEditUnit] = useState(false);
      const [error, setError] = useState("");
      const [productError, setProductError] = useState("");
      const [unitError, setUnitError] = useState("");
      const [quantityError, setQuantityError] = useState("");
      const handleAdd = () => {
        let hasError = false;
    
        if (!formik.values.equipmentId) {
          setProductError("Product is required");
          hasError = true;
        } else {
          setProductError("");
        }
    
        if (!formik.values.unit) {
          setUnitError("Unit is required");
          hasError = true;
        } else {
          setUnitError("");
        }
    
        if (!formik.values.quantity) {
          setQuantityError("Quantity is required");
          hasError = true;
        } else {
          setQuantityError("");
        }
    
        if (hasError) return;
    
        if (formik.values.equipmentId && formik.values.quantity) {
          const selectedProduct = Item.find(
            (i) => i.value === formik.values.equipmentId
          );
          const newItem = {
            equipmentId: formik.values.equipmentId,
            productName: sortedProList.find((i) => i.value === formik.values.equipmentId),
            quantity: formik.values.quantity,
            // unit:selectedProduct.unit
            unit: formik.values.unit,
          };
          setItems([...items, newItem]);
    
          setNewItemData({
            equipmentId:"",
       unit:"",
       sno:"",
       quantity:""
          });
          let updatedItems = Item.filter(
            (it) => it.value !== formik.values.equipmentId
          );
          setData(updatedItems);
          formik.values.equipmentId = "";
          formik.values.quantity = "";
          formik.values.unit = "";
          setError("");
        }
      };
    
      const handleQuantityChange = (e, index) => {
        const updatedQuantity = e.target.value;
    
        // Update the specific item's quantity
        const updatedItems = items.map((item, idx) => {
          if (idx === index) {
            return { ...item, quantity: updatedQuantity };
          }
          return item;
        });
    
        setItems(updatedItems); // Update the state with new quantity
      };
    
      const handleProductUnitChange = (value, index) => {
        const updatedItems = items.map((item, idx) => {
          if (idx === index) {
            return { ...item, unit: value?.value };
          }
          return item;
        });
        setItems(updatedItems);
      };
    
      const handleDeleteItem = (indexToDelete) => {
        const updatedItems = items.filter((_, index) => index !== indexToDelete);
        let ddUpdatedItem = items.find((_, i) => i === indexToDelete);
        setItems(updatedItems);
        let tempDd = ddUpdatedItem.productName;
        setData([...Item, tempDd]);
        // localStorage.setItem("items", JSON.stringify(updatedItems));
      };
     
     
    
    
  const [createNew, setCreateNew] = useState({
                   
        EquipmentId:"", 
        amount:"",
        attachments: [],
        clientId: "",       
        
        description: "",
        duration: "",
        endDate: "",
        formSelection: "",       
        inspectionType: "",       
       
        renewalDate: "",
        srId:null,
        startDate: "",
        status: "",
        equipments:""
        
   });

  const [selectedFile, setSelectedFile] = useState(null);
      const [image, setImage] = useState([]);
      const toast = useToast();
    
      function handleImageChange(e) {
        const maxFileSize = 200000000; // 200 MB
        const files = Array.from(e.target.files);
        let fileArr = [];
        files.map((item) => {
          if (item.size < maxFileSize) {
            fileArr.push(item);
          } else {
            toast.open({
              type: "warning",
              message: `File Size to big`,
              description: `${item.name} is Removed and not Uploaded`,
              // placement: "bottomRight",
            });
          }
        });
        let tempArr = [];
        setSelectedFile(fileArr);
        files.map((item) => {
          if (item.size < maxFileSize) {
            let fileName = item?.name;
            console.log("fname", fileName);
            // let fileExtention = fileName.split(".").reverse()[0];
            // if (filetype?.includes(fileExtention)) {
            tempArr.push(fileName);
            // } else {
            //   let x = URL.createObjectURL(item);
            //   tempArr.push(x);
            // }
          }
        });
        console.log(tempArr, "temp");
        setImage(tempArr);
      }
    
      const removeImages = (value) => {
        console.log("value", value);
        let List = selectedFile.filter((item) => item?.name !== value);
        console.log("LIst", List);
        setSelectedFile([...List]);
        let tempArr = [];
        List.map((item) => {
          let fileName = item?.name;
          // console.log('fname',fileName);
          // let fileExtention =  fileName.split(".").reverse()[0]
          // if(filetype?.includes(fileExtention)){
          tempArr.push(fileName);
          // }else{
          //   let x = URL.createObjectURL(item)
          //   tempArr.push(x)
          // }
        });
        setImage(tempArr);
      };
      const validationSchema = yup.object({
        startDate: yup.date().required('Start date is required'),
        endDate: yup
          .date()
          .required('End date is required')
          .min(yup.ref('startDate'), 'End date must be after start date'),
      
        inspectionDates: yup.array().of(
          yup.object().shape({
            date: yup
              .date()
              .required('Date is required')
              .test('within-range', 'Date must be between contract start and end', function (value) {
                const { startDate, endDate } = this.options.context;
                if (!value || !startDate || !endDate) return false;
      
                const dateVal = new Date(value);
                return dateVal >= new Date(startDate) && dateVal <= new Date(endDate);
              }),
          })
        ),
      });

      const [rows, setRows] = useState([]);

   const formik = useFormik({
    inspectionType: '',
      schedules:rows || "",
      duration: '',
      startDates: {
        1: '',
        2: '',
        3: '', // One entry per row ID
      },
     enableReinitialize: true,
     initialValues: createNew,
     validateOnChange: false,
     validateOnBlur: false,
     validationSchema,
     context: {
      startDate: createNew.startDate,
      endDate: createNew.endDate,
    },
     onSubmit: async (value, { resetForm }) => {
      let formData = new FormData();
      const valueWithItems = {
        ...value,
        equipments: items,
        schedules:rows,

      };
      formData.append("json_data", JSON.stringify(valueWithItems));
   if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("attachments", file);
        });
      } else {
        formData.append("attachments", []);
      }
            addFormData("/contract/new-contract", formData, resetForm);
     },
   });
   
   const [showPopup, setShowPopup] = useState(false);


   const togglePopup = () => {
     setShowPopup(!showPopup);
   };
 
   const resetForm = () => {
    //  formik.values.type = ""
     formik.values.companyName = "";
     formik.values.email = "";
     formik.values.industry = "";
       formik.values.category = "";
     // industry: "",
     formik.values.customerType = "";
     setShowPopup(false);
   }
 
   const handlePopupSubmit = async (e) => {
     e.preventDefault();
     
 
     const formData = new FormData();
     formData.append(
       "json_data",
       JSON.stringify({
        
         companyName: formik.values.companyName || "",
         email: formik.values.email || "",
         industry: formik.values.industry || "",
          category: formik.values.category || "",    
       
       })
     );
     try {
       const response = await axiosInstance.post(
         "/clients/new-client",
         formData
       );
           const createdAgent = response.data?.data;
 
           setDataCustomer((prevCustomers) => [
             {
               label: formik.values.companyName || "-",
               value: createdAgent
             },...prevCustomers
           ]);
           resetForm();
     } catch (error) {
       console.error("Error creating new customer:", error);
     }
   };
  
   const [showPopupEquipment, setShowPopupEquipment] = useState(false);


   const togglePopupEqupiment = () => {
     setShowPopupEquipment(!showPopupEquipment);
   };
 
   const resetFormE = () => {
   
     formik.values.name = "";
     formik.values.brand = "";
     formik.values.unit = "";
       formik.values.model = "";
     
     
     setShowPopupEquipment(false);
   }
 
   const handlePopupSubmitEquipmt = async (e) => {
     e.preventDefault();
     
 
     const formData = new FormData();
     formData.append(
       "json_data",
       JSON.stringify({
        
         name: formik.values.name || "",
         brand: formik.values.brand || "",
         unit: formik.values.unit || "",
          model: formik.values.model || "",
    
       
       })
     );
     try {
       const response = await axiosInstance.post(
         "/equipments/new-equipment",
         formData
       );
           const createdEquipt = response.data?.data;
 
           setDataequipments((prevEquipments) => [
             {
               label: formik.values.name || "-",
               value: createdEquipt
             },...prevEquipments
           ]);
           resetFormE();
     } catch (error) {
       console.error("Error creating new customer:", error);
     }
   };
 
   useEffect(()=>{
    if(Item){
      const union = Array.from(
        new Map([...Item, ...oldData].map((item) => [item.value, item])).values()
      );
      let data = union.sort((a, b) => a.label.localeCompare(b.label))
      setSortedProList(data)
    }    
  },[Item])

  useEffect(() => {
    if (formik.values.equipmentId) {
      const findValue = sortedProList.filter((v) => formik.values?.equipmentId ==(v.value));
      setOldData(findValue);
    }
    console.log("Testing",formik.values.equipmentId);
  },[formik.values.equipmentId])
  const handleInputChange = (e, rowIndex, key) => {
    const updatedRows = [...deliveryRows];
    updatedRows[rowIndex][key] = e.target.value;
    setDeliveryRows(updatedRows);
  };
  const handleAddRow = () => {
    setDeliveryRows([
      ...deliveryRows,
      {
        col1: "",
        col2: "",
        col3: "",
        col4: "",
        col5: "",
        col6: "",
        col7: "",
      },
    ]);
  };
  const [startDate, setStartDate] = useState(format(now, 'yyyy-MM-dd'));
  const [time, setTime] = useState(format(now, 'HH:mm'));
  const inspectionMap = {
    Monthly: 1,
    Quarterly: 3,
    HalfYearly: 6,
    Yearly: 12
  };
  
  const calculateInspectionRows = (inspectionType, duration) => {
    const interval = inspectionMap[inspectionType];
    const totalMonths = parseInt(duration);

    if (!interval || !totalMonths) return [];

    return Array.from({ length: Math.floor(totalMonths / interval) }, (_, i) => {
      const date = addMonths(new Date(startDate + 'T' + time), (i + 1) * interval - interval);
      return {
        id: i + 1,
        date: format(date, 'yyyy-MM-dd'),
        time: format(date, 'HH:mm')
      };
    });
  };

  useEffect(() => {
    const { inspectionType, duration } = formik.values;
    const updatedRows = calculateInspectionRows(inspectionType, duration);
    setRows(updatedRows);
  }, [formik.values.inspectionType, formik.values.duration, startDate, time]);

  useEffect(() => {
    if (formik.submitCount > 0 && formik.errors.inspectionDates) {
      formik.errors.inspectionDates.forEach((item, index) => {
        if (item?.date) {
          toast.open({
            type: 'warning',
            message: `Inspection ${index + 1}`,
            description: `Inspection date must be between contract start date and end date`,
          });
        }
      });
    }
  }, [formik.submitCount, formik.errors.inspectionDates]);

 
   return (
     <div className=" w-full h-full py-2 px-4 ">
          <div className="flex justify-between w-full">  
            <Breadcrumb
                                items={[
                       
                                  
                                  {
                                    name: "Contracts",
                                    link:"/client-management/contracts"
                                   
                                  },
                      
                                  { name: "Create" },
                                ]}
                              />     
         <BackButton />
       </div>
       <div className="w-full mx-auto h-[calc(100vh-151px)] overflow-y-auto mt-4">

       <form onSubmit={formik.handleSubmit}>
           <div className=" w-full h-full flex justify-start rounded-md  bg-white content-start flex-wrap py-2 px-4  overflow-y-auto">
             <div className="w-full">
               <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                 Contracts :
               </p>
             </div>
             <NuInput
               type="text"
               label="Description"
               placeholder="Type here"
               formik={formik}
               name="description"
               width="w-full md:w-2/3 md:-mt-2"
             />
            
              <FormikSelectTwo
                    label="Client "
                    placeholder="Client  "
                    Options={client}
                    formik={formik}
                    name="clientId"
                    isRequired={true}
                    width="w-full md:w-1/3 md:-mt-2"
                    handleClick={togglePopup}
                    
                    setSearch={setSearchClient}
                  />
                  <FormikSelectTwo
               label="Survey Report"
               Options={Survey}
               formik={formik}
               placeholder="Choose"
               name="srId"
               isRequired={true}
               width="w-full md:w-1/3 md:-mt-2"
             />
                  
               {/* <NuDate
               label="Date"
               formik={formik}
               name="date"
               width="w-full md:w-1/3 md:-mt-2"
             /> */}
              <NuInput
               type="number"
               label="Amount"
               placeholder="Amount"
               formik={formik}
               name="amount"
               width="w-full md:w-1/3 md:-mt-2"
             />
            
              <FormikSelectTwo
                            label="Contract Duration"
                            placeholder="Choose"
                            Options={[
                              { value: "1 Month", label: "1 month" },
                              { value: "3 Months", label: "3 Months" },
                              { value: "6 Months", label: "6 Months" },
                              { value: "12 Months", label: "12 Months" },
                              { value: "24 Months", label: "24 Months" },
                              { value: "36 Months", label: "36 Months" },
                            ]}
                            formik={formik}
                            name="duration"
                            width="w-full md:w-1/3 md:-mt-2 "
                            // onChange={formik.handleChange}
                            // value={formik.values.duration}
              
                          />
              <NuDate
               label=" Contract Start Date"
               formik={formik}
               name="startDate"
               width="w-full md:w-1/3 md:-mt-2"
             />
              <NuDate
               label=" Contract End Date"
               formik={formik}
               name="endDate"
               width="w-full md:w-1/3 md:-mt-2"
             />
              <NuDate
               label=" Contract Renewal Date"
               formik={formik}
               name="renewalDate"
               width="w-full md:w-1/3 md:-mt-2"
             />
         
                        
      
             <div className="w-full">
                <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                   Attachement :
                </p>
              </div>
              <Attachement
                handleChange={handleImageChange}
                preview={image || ""}
                width="w-full"
                label="Attach"
                multiple={true}
                removeImages={removeImages}
              />
            
            
             {/* <div className="w-full hidden md:block mx-auto my-4 mt-8 ">
               <div className="md:flex justify-end gap-4">
                 <CancelButton
                   handleClick={() => {
                     navigate(-1);
                   }}
                 />
                 <SubmitButton />
               </div>
             </div> */}
           </div>
      
         <div className="w-full mx-auto  bg-white rounded-md pb-4 mt-4 ">
            <div className=" w-full h-full flex justify-start content-start flex-wrap  mb-4">
              <div className="w-full">
                <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-baseColor-primary decoration-2 underline-offset-4">
                  Equpments :
                </p>
              </div>
              <div className="w-full px-2 m-2 flex flex-col md:flex-row gap-y-3 md:gap-y-0 justify-start gap-3 border border-solid rounded-lg">
                <SelectProductWithError
                  type="text"
                  label="Equipment "
                  placeholder="Equipment "
                  Options={sortedProList}
                  formik={formik}
                  name="equipmentId"
                  width="w-full md:w-1/2 lg:w-[67%]"
                  ErrMessage={productError}
                  px="0"
                  handleClick={togglePopupEqupiment}
                  setSearch={setSearchequipment}
                  FixPosition={false}
                  PortalTarget={false}
                />
                <DropDownAddUnitWithError
                  label="Unit"
                  placeholder="Choose"
                  Options={unit}
                  formik={formik}
                  name="unit"
                  width="w-full md:w-1/2 lg:w-1/4"
                  getFunc={refunit}
                  displayProperty={"Add Unit"}
                  propertyName={"unit_equipments"}
                  ErrMessage={unitError}
                  FixPosition={false}
                  PortalTarget={false}
                />
               
                <NuInputWithError
                  label="Quantity"
                  type="number"
                  formik={formik}
                  placeholder="Quantity"
                  name="quantity"
                  width="w-full md:w-1/2 lg:w-1/4 "
                  ErrMessage={quantityError}
                />
                <button
                  onClick={handleAdd}
                  type="button"
                  className=" p-1 mt-8 m-1 text-center h-8 cursor-pointer bg-baseColor-primary border border-solid border-white  text-xs font-medium  text-white  rounded-lg "
                >
                  Add
                </button>
              </div>
              <div className="w-full bg-white overflow-y-scroll mt-5">
                {error && (
                  <p className="text-xs font-semibold text-red-500">{error}</p>
                )}
                <div className="w-full py-3  bg-baseColor-primary flex justify-between rounded-lg px-6">
                  <p className="w-[5%]  text-left  text-white text-xs font-medium">
                    S.No{" "}
                  </p>

                  <p className=" w-[55%] text-left text-white text-xs font-medium">
                    Equipment
                  </p>
                  <p className=" w-[15%] text-center pl-4 text-white text-xs font-medium flex justify-center">
                    Unit
                    <span
                      className="pl-1 cursor-pointer"
                      onClick={() => {
                        setIsEditUnit((prv) => !prv);
                      }}
                    >
                      {isEditUnit === true && (
                        <EditIcon width={"14"} height={"14"} color="yellow" />
                      )}
                      {isEditUnit === false && (
                        <EditIcon width={"14"} height={"14"} />
                      )}
                    </span>
                  </p>
                  <p className=" w-[20%] text-center  text-white text-xs font-medium flex justify-center">
                    Quantity
                    <span
                      className="pl-1 cursor-pointer"
                      onClick={() => {
                        setIsEditQua((prv) => !prv);
                      }}
                    >
                      {isEditQua === true && (
                        <EditIcon width={"14"} height={"14"} color="yellow" />
                      )}
                      {isEditQua === false && (
                        <EditIcon width={"14"} height={"14"} />
                      )}
                    </span>
                  </p>

                  <p className=" w-[5%] text-right text-white text-xs font-medium">
                    Action
                  </p>
                </div>
                {items?.length > 0 ? (
                  <div className="h-[calc(100vh-300px)] overflow-y-scroll">
                    {items.map((List, index) => {
                      return (
                        <div
                          key={index}
                          className="w-full py-2 flex justify-between px-6  odd:bg-white even:bg-slate-50"
                        >
                          <p className="w-[5%]  text-left   text-xs font-medium text-[#111537] py-2.5">
                            {List?.sno}
                          </p>
                          <p className=" w-[55%] text-left  text-xs font-medium text-[#111537] py-2.5">
                            {List?.productName?.label||""}
                          </p>
                          <p className=" w-[15%] text-center pl-4  text-xs font-medium text-[#111537]">
                            {/* {List?.unit} */}
                            <Select
                              value={
                                unit.find(
                                  (item) => item?.value == List.unit
                                ) || List.unit
                              }
                              options={isEditUnit ? unit : []}
                              className="w-full"
                              onChange={(value) =>
                                handleProductUnitChange(value, index)
                              }
                              isDisabled={!isEditUnit}
                            />
                          </p>

                          <p className=" w-[20%] text-center   text-xs font-medium text-[#111537] py-2.5">
                            <input
                              type="number"
                              className=" w-11/12 mx-auto outline-none text-center"
                              value={List?.quantity}
                              disabled={!isEditQua}
                              onChange={(e) => handleQuantityChange(e, index)}
                            />
                          </p>

                          <div className="w-[5%] text-right py-2.5">
                            <button
                              onClick={() => handleDeleteItem(index)}
                              type="button"
                              className="text-red-500 cursor-pointer  ml-4 border-none"
                            >
                              <DeleteIcon color="red" height={12} />
                            </button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="w-full text-center text-[#93949f]">
                    No Items here
                  </div>
                )}
              </div>
       
              
            
            </div>
          </div>
          <div className="w-full mx-auto  bg-white rounded-md  mt-4 ">
            <div className=" w-full h-full flex justify-start content-start flex-wrap   mb-4">
            <div className="w-full">
                <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-[#3369ff] decoration-2 underline-offset-4">
                 Inspection :
                </p>
              </div>

              <FormikSelectTwo
                            label="Inspection Type"
                            // isClearable={true}
                            placeholder="Choose"
                            Options={[
                              { value: "Monthly", label: "Monthly" },
                              { value: "Quarterly", label: "Quarterly" },
                              { value: "Half-yearly", label: "Half-yearly" },
                              { value: "Yearly", label: "Yearly" },
                            
                            ]}
                            formik={formik}
                            // onChange={formik.handleChange} 
                            // value={formik.values.inspectionType}
                            name="inspectionType"
                            width="w-full md:w-1/3 md:-mt-2  "
                            // getFunc={refinspectionType}
                            // displayProperty={"Inspection Type"}
                            // propertyName={"Inspection_Type_Contracts"}
                            // FixPosition={false}
                            // PortalTarget={false}
              
                          />  
                        
                             <MultiSelect
               label="Form Selection"
               Options={form}
               formik={formik}
               placeholder="Choose"
               name="formSelection"
               isRequired={true}
               width="w-full md:w-1/3 md:-mt-2"
             />
  {formik.values.duration && formik.values.inspectionType && (             
 <div className="overflow-x-auto flex  gap-4 p-7 w-full">
 <table className="w-[30%] text-xs border  border-gray-300 ">
   <thead className="bg-gray-100 h-10">
     <tr className=" w-full" >
      <th className=" text-center ">Inspection </th>
      <th className=" text-center">Start Date </th>
      {/* <th className="border px-4 py-2">Months</th> */}
      
     </tr>
   </thead>
 
   <tbody>
   {rows.map((schedule, index) => (
            <tr key={index}>
              <td className=" px-4 py-2 text-center">{index + 1}</td>
              <td className=" px-4 py-2 text-center"> <NuDate
              //  label="Date"
               formik={formik}
               name={`inspectionDates.${index}.date`}
               width="w-ful"
             /></td>
             {/* {formik.errors.inspectionDates?.[index]?.date && (
            <p className="text-red-500  ">
              {formik.errors.inspectionDates[index].date}
  </p>
)} */}
              {/* <td className="border px-4 py-2">{schedule.time}</td> */}
            </tr>
            
          ))}
   </tbody>
 </table>
 <div className="">

</div>
</div>
)}
            
                            <div className="w-full hidden md:block mx-auto my-4 mt-8 pb-2">
                <div className="md:flex justify-end gap-4">
                  <CancelButton
                    handleClick={() => {
                      Oncancel(-1);
                    }}
                  />
                  <SubmitButton isLoading={isLoading} />
                </div>
              </div>   
            </div>
          
          </div>
       </form>
       </div>



       {showPopup && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in w-[60%] max-h-[80vh] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll ">
            <h2 className="text-lg font-normal text-[12px]">Add Client</h2>
            <form onSubmit={handlePopupSubmit}>
              <div className="mb-4 flex flex-wrap">
               
                <NuInput
                  type="text"
                  label="Company Name"
                  placeholder="Company Name"
                  formik={formik}
                  name="companyName"
                  width="w-full md:w-1/2 lg:w-1/2"
                  isRequired={true}
                />
              
                <NuInput
                  type="email"
                  label="Email"
                  placeholder="Email"
                  formik={formik}
                  name="email"
                  width="w-full md:w-1/2 lg:w-1/2"
                  isRequired={true}
                />
                <NuInput
                  type="text"
                  label="Industry"
                  placeholder="Industry"
                  formik={formik}
                  name="industry"
                  width="w-full md:w-1/2 lg:w-1/2"
                />
                <DropDownAddMetaData
                label="Category"
                placeholder="Choose"
                Options={supplierCat}
                formik={formik}
                name="category"
                width="w-full md:w-1/2 lg:w-1/2"
                getFunc={refsupplierCat}
                displayProperty={"Category"}
                propertyName={"SupplierCategory"}
              />
              </div>
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={togglePopup}
                  className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm bg-[#E6F2F2]  hover:bg-gray-300
                  rounded-md flex items-center mr-2 text-textColor-main"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-textColor-main px-5 py-[9px] cursor-pointer outline-none border-none text-white rounded-md text-xs 2xl:text-sm flex items-center"
                >
                  Add
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
       {showPopupEquipment && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in w-[60%] max-h-[80vh] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll ">
            <h2 className="text-lg font-normal text-[12px]">Add Equipment</h2>
            <form onSubmit={handlePopupSubmitEquipmt}>
              <div className="mb-4 flex flex-wrap">
               
              <NuInput
                label="Name"
                placeholder="Name"
                formik={formik}
                name="name"
                width="w-full"
                new_width="w-full"
  
              />
              <DropDownAddMetaData
                            label="Unit"
                            placeholder="Choose"
                            Options={unit}
                            formik={formik}
                            name="unit"
                            width="w-full "
                            getFunc={refunit}
                            displayProperty={"unit"}
                            propertyName={"unit_equipments"}
                            FixPosition={false}
                            PortalTarget={false}
                isRequired={true}
  
                          />
                          <DropDownAddMetaData
                            label="Brand"
                            placeholder="Choose"
                            Options={brand}
                            formik={formik}
                            name="brand"
                            width="w-full "
                            getFunc={refbrand}
                            displayProperty={"brand"}
                            propertyName={"brand_equipments"}
                            FixPosition={false}
                            PortalTarget={false}
                isRequired={true}
  
                          />
               <NuInput
                label="Model no"
                placeholder="Model no"
                formik={formik}
                name="model"
                width="w-full"
                new_width="w-full"
  
              />
              </div>
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={togglePopupEqupiment}
                  className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm bg-[#E6F2F2]  hover:bg-gray-300
                  rounded-md flex items-center mr-2 text-textColor-main"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-textColor-main px-5 py-[9px] cursor-pointer outline-none border-none text-white rounded-md text-xs 2xl:text-sm flex items-center"
                >
                  Add
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
     </div>
   );
 }
 
export default CreateContracts
